module.exports = __webpack_public_path__ + "img/l5.1cf41cd8.png";